import { A } from "@solidjs/router";
import { Suspense, createResource,createSignal, onMount } from "solid-js";
import { folderCount } from "~/utils";
import Spinner from "~/components/Spinner";

const getFolderCount = async ( folder: string ): Promise<number> => {
  "use server";

  const count = await folderCount( folder );

  return count;
};

const Home = () => {
  const [mounted, setMounted] = createSignal( false );

  const [assetCount] = createResource( mounted, () => getFolderCount( '_assets/_xsl/' ) );
  const [collectionCount] = createResource( mounted, () => getFolderCount( 'genie-tools/collections/' ) );
  const [renderCount] = createResource( mounted, () => getFolderCount( '_lookup/renders/' ) );

  onMount( () => setMounted( true ) );


  return (
    <dl class="min-w-1/2 mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
      <A href="/assets">
        <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow-sm sm:p-6">
          <dt class="truncate text-sm font-medium text-gray-500">Assets</dt>
          <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900"><Suspense fallback={<Spinner size={36} />}>{assetCount() ?? 'n/a'}</Suspense></dd>
        </div>
      </A>
      <A href="/collections">
        <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow-sm sm:p-6">
          <dt class="truncate text-sm font-medium text-gray-500">Collections</dt>
          <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900"><Suspense fallback={<Spinner size={36} />}>{collectionCount() ?? 'n/a'}</Suspense></dd>
        </div>
      </A>
      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow-sm sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">Renders</dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900"><Suspense fallback={<Spinner size={36} />}>{renderCount() ?? 'n/a'}</Suspense></dd>
      </div>
    </dl>
  );
}

export default Home;